
// elements that begin and end at resting position
export const standard    = 'cubic-bezier(0.4, 0.0, 0.2, 1)';

// incoming elements
export const decelerated = 'cubic-bezier(0.0, 0.0, 0.2, 1)';

// outgoing elements
export const accelerated = 'cubic-bezier(0.4, 0.0, 1, 1)';